"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function OwnedLicenseAssign(row) {
  var targetEntity = row.targetEntity,
    sourceEntity = row.sourceEntity;
  if (targetEntity && sourceEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Assigned license from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " to ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (targetEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Assigned license from an unknown group to ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (sourceEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Assigned license from ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), " to an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Assigned license from unknown group to an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
}
var _default = exports["default"] = OwnedLicenseAssign;